import { createAction } from '@reduxjs/toolkit';

import { name } from './slice';
import type { ActiveHotelProps, PopupState } from './types';

export const getMapDataAction = createAction(`${name}/getMapData`);

export const setActiveHotelDataAction = createAction<ActiveHotelProps>(
  `${name}/setActiveHotelData`,
);

export const setHotelPopupDataAction = createAction<PopupState>(
  `${name}/setHotelPopupData`,
);
